import CaseFolders from "../CaseFolders";
import Notifications from "../Notifications";
import Overview from "../Overview";

import Settings from "../Settings";

import ViewCaseFolder from "../case-folder/ViewCaseFolder";

import Panels from "../Panels";
import PanelsDocket from "../PanelsDocket";
import CauseLists from "../CauseLists";

export const PresidentRoute = [
  {
    title: "Overview",
    path: "/president/overview",
    component: Overview,
  },
  {
    title: "Case Folders",
    path: "/president/case-folders",
    component: CaseFolders,
  },

  {
    title: "View Case Folder",
    path: "/president/case-folders/view",
    component: ViewCaseFolder,
  },
  {
    title: "Panel",
    path: "/president/panels",
    component: Panels,
  },
  {
    title: "Docket",
    path: "/president/panels/docket",
    component: PanelsDocket,
  },
  {
    title: "Cause Lists",
    path: "/president/cause-lists",
    component: CauseLists,
  },

  {
    title: "Notification",
    path: "/president/notification",
    component: Notifications,
  },
  {
    title: "Setting",
    path: "/president/setting",
    component: Settings,
  },
];
